import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Entity } from '@app/core/model/entities/entity';
import { Expose } from 'class-transformer';

export class BiReport extends Entity {
  public objectType = EntityTypeEnum.BI_REPORT;
  public organizationId?: string;
  public userId?: number;
  public assetTypeId: string;
  public reportId: string;
  public reportType: ReportType;
  public entityType: EntityTypeEnum;
  public lastRefreshTime: string;
  public refreshStatus: string;

  @Expose()
  public toString(): string {
    return this.name;
  }

  /**
   * Convert this bi report instance to a CreateBiReportInput instance.
   * @return CreateBiReportInput
   */
  public toCreateBiReportInput() {
    return {
      organizationId: this.organizationId,
      userId: this.userId,
      name: this.name,
      reportId: this.reportId,
      reportType: this.reportType,
      entityType: this.entityType,
      assetTypeId: this.assetTypeId,
      properties: this.properties
    };
  }

  /**
   * Convert this bi report instance to an UpdateBiReportInput instance.
   * @return UpdateBiReportInput
   */
  public toUpdateBiReportInput(): UpdateBiReportInput {
    return {
      id: this.id,
      name: this.name,
      reportId: this.reportId,
      properties: this.properties
    };
  }
}

export type CreateBiReportInput = {
  organizationId?: string;
  userId?: number;
  name: string;
  reportId: string;
  reportType: ReportType;
  entityType: EntityTypeEnum;
  assetTypeId?: string;
  properties: Record<string, any>;
};

export type UpdateBiReportInput = {
  id: string;
  name: string;
  reportId: string;
  properties: Record<string, any>;
};

export enum ReportType {
  BI = 'BI',
  PAGINATED = 'PAGINATED'
}
